import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = { class: "scbd co-default" }
const _hoisted_5 = {
  class: "detail",
  style: {"position":"relative"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 0,
  class: "hgroup"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "conbody" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "btngroup" }

import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/bbs/Sidebar.vue";
import SubLoading from "@/components/SubLoading.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import type { Qna } from "@/model/qna";

const getQna = "getBoard";


export default /*@__PURE__*/_defineComponent({
  __name: 'Content',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const faqItem = ref<Qna | null>(null);
const isLoading = ref(false);
const error = ref<string | null>(null);
const contentMessage = ref<string | null>(null);

const getCallApiCallable = getCallable("callApi");
const loadFaqDetail = async (sk: string) => {
  contentMessage.value = ""; // 이전 내용 초기화
  isLoading.value = true;
  error.value = null;
  try {
    let param = makeCallApiParam(getQna, {
      boardType: constant.boardType.QNA,
      SK: sk,
    });
    const result: any = await getCallApiCallable(param);
    if (common.evalFunctionResult(result)) {
      faqItem.value = common.getItemFromFunctionResult(result);
      contentMessage.value = faqItem.value.answer;
    } else {
      throw new Error(common.getResultError(result) || "FAQ 조회 실패");
    }
  } catch (err) {
    console.error("FAQ 로딩 실패:", err);
    error.value = "FAQ 불러오는데 실패했습니다. 잠시 후 다시 시도해주세요.";
    contentMessage.value = "표시할 내용이 없습니다.";
    faqItem.value = null;
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  const faqId = route.params.id as string;
  if (faqId) {
    loadFaqDetail(faqId);
  } else {
    error.value = "잘못된 접근입니다.";
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "FAQ",
      subtitle: "FAQ",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("FAQ"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (isLoading.value)
              ? (_openBlock(), _createBlock(SubLoading, { key: 0 }))
              : (error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("p", null, _toDisplayString(error.value), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (faqItem.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("h1", null, _toDisplayString(faqItem.value.question), 1),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, _toDisplayString(faqItem.value.author), 1),
                            _createElementVNode("li", null, _toDisplayString(common.getYYYYMMDD2(faqItem.value.createdDate)), 1),
                            (faqItem.value.ip)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(faqItem.value.ip), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", { innerHTML: contentMessage.value }, null, 8, _hoisted_11)
                    ])
                  ])),
            _createElementVNode("div", _hoisted_12, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "divider-line" }, null, -1)),
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Qna.Path}`,
                class: "ui-button"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("목록")
                ])),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})